import RBPagination from 'react-bootstrap/Pagination';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { usePagination } from './usePagination';

interface Props {
  count: number;
  pageSize: number;
  currentPage: number;
  siblingCount?: number;
  onChangePage: (page: number) => void;
}

export const Pagination = ({
  count,
  pageSize,
  currentPage,
  siblingCount = 1,
  onChangePage,
}: Props) => {
  const paginationRange = usePagination({
    count,
    pageSize,
    currentPage,
    siblingCount,
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const lastPage = paginationRange.at(-1);

  return (
    <RBPagination className="text-center m-0">
      <RBPagination.Prev
        style={{ width: '45px' }}
        disabled={currentPage === 1}
        onClick={() => onChangePage(currentPage - 1)}
      >
        <BsChevronLeft className="pagination-item__icon" viewBox={'0 0 18 18'} />
      </RBPagination.Prev>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === '...') {
          return <RBPagination.Ellipsis key={`ellipsis-${index}`} style={{ width: '45px' }} />;
        }
        return (
          <RBPagination.Item
            key={pageNumber}
            style={{ width: '45px' }}
            active={pageNumber === currentPage}
            onClick={() => onChangePage(pageNumber)}
          >
            {pageNumber}
          </RBPagination.Item>
        );
      })}
      <RBPagination.Next
        style={{ width: '45px' }}
        disabled={currentPage === lastPage}
        onClick={() => onChangePage(currentPage + 1)}
      >
        <BsChevronRight className="pagination-item__icon" viewBox={'0 0 18 18'} />
      </RBPagination.Next>
    </RBPagination>
  );
};
